// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1465":"a645122ecbd27170","9285":"da17133ad76f001d"}[chunkId] + ".js";
};